var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonialsBgTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 245,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850.057 0.341697C850.057 134.909 740.926 243.998 606.307 243.998C471.688 243.998 362.557 134.909 362.557 0.34174",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M859.748 0.341284C859.748 124.143 750.617 224.62 615.998 224.62C481.379 224.62 372.248 124.143 372.248 0.341326",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M869.439 0.342411C869.439 113.379 760.308 205.244 625.689 205.244C491.07 205.244 381.939 113.379 381.939 0.342454",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M879.486 0.34518C879.486 102.616 770.355 185.51 635.736 185.51C501.117 185.51 391.986 102.616 391.986 0.345222",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M889.184 0.341786C889.184 91.8476 780.052 166.129 645.434 166.129C510.815 166.129 401.684 91.8476 401.683 0.341828",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M898.881 0.340366C898.881 81.0808 789.75 146.75 655.131 146.75C520.512 146.75 411.381 81.0809 411.381 0.340409",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M908.564 0.341563C908.564 70.3166 799.433 127.014 664.814 127.014C530.195 127.014 420.705 70.3166 420.705 0.341606",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M918.262 0.342955C918.262 59.5526 809.131 107.638 674.512 107.638C539.893 107.638 430.762 59.5527 430.762 0.342998",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M928.312 0.344619C928.312 48.7889 819.181 88.262 684.562 88.262C549.944 88.262 440.813 48.7889 440.812 0.344662",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M938.006 0.342591C938.006 38.0215 828.875 68.5234 694.256 68.5234C559.637 68.5234 450.506 38.0215 450.506 0.342633",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M947.695 0.342949C947.695 27.2564 838.564 49.1461 703.945 49.1461C569.326 49.1461 460.195 27.2565 460.195 0.342991",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M957.391 0.342408C957.391 16.4905 848.26 29.7679 713.641 29.7679C579.022 29.7679 469.891 16.4905 469.891 0.342451",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M606.303 0.343266C606.303 134.911 715.434 244 850.053 244C984.672 244 1094.16 134.911 1094.16 0.343223",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M596.613 0.344744C596.613 124.147 705.744 224.624 840.363 224.624C974.982 224.624 1084.11 124.147 1084.11 0.344702",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M586.557 0.342896C586.557 113.38 695.688 205.244 830.307 205.244C964.926 205.244 1074.42 113.379 1074.42 0.342854",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M576.871 0.344627C576.871 102.616 686.002 185.509 820.621 185.509C955.24 185.509 1064.73 102.616 1064.73 0.344585",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M567.174 0.340699C567.174 91.8465 676.305 166.128 810.924 166.128C945.543 166.128 1055.03 91.8465 1055.03 0.340656",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M557.483 0.340714C557.483 81.0812 666.614 146.75 801.233 146.75C935.852 146.75 1045.34 81.0811 1045.34 0.340671",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M547.789 0.343269C547.789 70.3183 656.92 127.016 791.539 127.016C926.158 127.016 1035.29 70.3183 1035.29 0.343226",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M537.737 0.343944C537.737 59.5536 646.868 107.639 781.487 107.639C916.106 107.639 1025.6 59.5536 1025.6 0.343901",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M528.043 0.34277C528.043 48.787 637.174 88.2601 771.793 88.2601C906.412 88.2601 1015.54 48.787 1015.54 0.342727",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M518.351 0.342114C518.351 38.021 627.483 68.5229 762.102 68.5229C896.72 68.5229 1005.85 38.0209 1005.85 0.342072",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M508.658 0.344456C508.658 27.2579 617.789 49.1476 752.408 49.1476C887.027 49.1476 996.158 27.2579 996.158 0.344413",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M498.965 0.342664C498.965 16.4908 608.096 29.7681 742.715 29.7681C877.334 29.7681 986.465 16.4907 986.465 0.342622",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M489.275 0.344593C489.275 5.72729 598.406 10.0335 733.025 10.0335C867.644 10.0335 976.775 5.72725 976.775 0.34455",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M967.082 0.341285C967.082 5.72398 857.951 10.0302 723.332 10.0302C630.355 10.0302 549.584 7.87705 508.301 5.00628",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.443 0.343159C118.443 134.911 227.574 244 362.193 244C496.812 244 605.943 134.911 605.943 0.343116",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.752 0.342959C108.752 124.145 217.883 224.622 352.502 224.622C487.121 224.622 596.611 124.145 596.611 0.342916",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6971 0.342805C98.6971 113.379 207.828 205.244 342.447 205.244C477.066 205.244 586.197 113.379 586.197 0.342762",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0117 0.344414C89.0117 102.616 198.143 185.509 332.762 185.509C467.381 185.509 576.512 102.616 576.512 0.344371",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3144 0.340653C79.3144 91.8465 188.445 166.128 323.064 166.128C457.683 166.128 566.814 91.8464 566.814 0.340611",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.623 0.340607C69.623 81.0811 178.754 146.75 313.373 146.75C447.992 146.75 557.123 81.081 557.123 0.340565",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9296 0.342719C59.9296 70.3178 169.061 127.015 303.68 127.015C438.299 127.015 547.43 70.3177 547.43 0.342677",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2362 0.344951C50.2362 59.5546 159.367 107.64 293.986 107.64C428.605 107.64 537.736 59.5546 537.736 0.344908",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1816 0.345119C40.1816 48.7894 149.313 88.2625 283.932 88.2625C418.551 88.2625 527.682 48.7893 527.682 0.345077",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.492 0.342938C30.4921 38.0218 139.623 68.5237 274.242 68.5237C408.861 68.5237 517.992 38.0218 517.992 0.342896",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7969 0.342228C20.7969 27.2557 129.928 49.1454 264.547 49.1453C399.166 49.1453 508.297 27.2557 508.297 0.342186",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1093 0.345014C11.1093 16.4931 120.24 29.7704 254.859 29.7704C389.478 29.7704 498.609 16.4931 498.609 0.344971",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41602 0.343738C1.41602 5.72643 110.547 10.0326 245.166 10.0326C379.785 10.0326 488.916 5.72639 488.916 0.343695",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M479.219 0.344397C479.219 5.72709 370.088 10.0333 235.469 10.0333C142.492 10.0333 61.7205 7.88017 20.4373 5.0094",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsBgTop);
export default __webpack_public_path__ + "static/media/testimonials-bg-top.b7688e2bba0af41a5b40fee8034e044c.svg";
export { ForwardRef as ReactComponent };